<template>
  <div class="md-layout">
    <validation-form @on-submit="validateRespondent">
      <!-- form input -->
      <div class="form-input mb-10">
        <div class="md-layout mt-15">
          <label
            class="
              md-layout-item md-size-100 md-small-size-100
              text-base
              font-medium
            "
          >
            {{ $t("survey.general_info") }}
          </label>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-field
              :validations="gerneralLocal.survey_validation.name"
              name="survey title"
            >
              <label>{{ $t("survey.filter_by_title") }}</label>
              <md-input
                v-model.trim="gerneral_information.title"
                :disabled="isReadOnly"
                :maxlength="gerneralLocal.survey_validation.name.maxLength"
                required
              ></md-input>
              <span
                v-if="gerneralLocal.serverValidations.name"
                class="md-error"
                >{{ gerneralLocal.serverValidations.name }}</span
              >
            </validation-field>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <label> {{ $t("survey.description_survey") }}</label>
            <Editor
              v-model="gerneral_information.description"
              :disabled="isReadOnly"
              :init="editorInit"
            />
          </div>
          <label
            class="
              md-layout-item md-size-100 md-small-size-100
              text-base
              font-medium
              pt-4
            "
          >
            {{ $t("survey.expired_date") }}
          </label>
          <div
            class="
              md-layout-item md-size-33 md-small-size-100 md-layout
              relative
              pl-0
              pt-1
            "
          >
            <div class="md-layout-item md-size-100 md-small-size-100">
              <date-picker-custom
                v-model="gerneral_information.effective_end_date"
                :disabledDate="disabledDate"
                :label="$t('extended_exportation.enter_date')"
              >
                <div class="flex absolute top-[2.5rem] left-0">
                  <img alt="" src="../Img/Deadline.svg" />
                  <span class="text-xs ml-[0.5rem]">{{
                    $t("survey.deadline_survey")
                  }}</span>
                </div>
              </date-picker-custom>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <div v-if="isReadOnly" class="date-disabled not-allowed"></div>
            </div>
          </div>
          <label
            class="
              md-layout-item md-size-100 md-small-size-100
              text-base
              font-medium
              pt-4
              required
            "
          >
            {{ $t("survey.responsedent_setting") }}
          </label>
          <RespondentSetting
            ref="studentSetting"
            :disabled="isReadOnly"
            :filterList="gerneralLocal.STUDENT_LIST"
            :isRoleTeacher="isRoleTeacher"
            :isSettingEdit="isSettingEdit"
            :listOptions="listOptions.student"
            :respondentFilterProps="
              gerneral_information.respondent_setting.student
            "
            :settingProps="gerneralLocal.respondent.student"
            label="common.student"
            value="student"
            @checkRespondent="checkRespondent"
          >
          </RespondentSetting>
          <RespondentSetting
            ref="familySetting"
            :disabled="isReadOnly"
            :filterList="gerneralLocal.FAMILY_LIST"
            :isRoleTeacher="isRoleTeacher"
            :isSettingEdit="isSettingEdit"
            :listOptions="listOptions.family"
            :respondentFilterProps="
              gerneral_information.respondent_setting.family
            "
            :settingProps="gerneralLocal.respondent.family"
            label="common.family"
            value="family"
            @checkRespondent="checkRespondent"
          >
          </RespondentSetting>
          <RespondentSetting
            v-if="!isRoleTeacher"
            ref="teacherSetting"
            :disabled="isReadOnly"
            :filterList="gerneralLocal.TEACHER_LIST"
            :isSettingEdit="isSettingEdit"
            :listOptions="listOptions.teacher"
            :respondentFilterProps="
              gerneral_information.respondent_setting.teacher
            "
            :settingProps="gerneralLocal.respondent.teacher"
            label="common.teacher"
            value="teacher"
            @checkRespondent="checkRespondent"
          >
          </RespondentSetting>
          <RespondentSetting
            v-if="!isRoleTeacher"
            ref="otherSetting"
            :disabled="isReadOnly"
            :isSettingEdit="isSettingEdit"
            :listOptions="listOptions.other_staffs"
            :respondentFilterProps="
              gerneral_information.respondent_setting.other_staffs
            "
            :settingProps="gerneralLocal.respondent.other_staffs"
            label="survey.other_staff"
            value="other_staffs"
            @checkRespondent="checkRespondent"
          >
          </RespondentSetting>
          <span
            v-if="gerneralLocal.respondentedRequire"
            class="text-[#ff1744] pt-2"
          >
            {{ $t("survey.respondent_setting_require") }}
          </span>
          <label
            class="
              md-layout-item md-size-100 md-small-size-100
              text-base
              font-medium
              pt-3
            "
          >
            {{ $t("survey.appearance_report_setting") }}
          </label>
        </div>
        <div class="md-layout-item md-size-33 pt-[6px]">
          <md-checkbox
            v-model="gerneral_information.appearance_report_setting"
            :disabled="isReadOnly"
            >{{ $t("survey.make_responses_anonymous") }}
          </md-checkbox>
        </div>
      </div>
      <!-- btn -->
      <div class="md-layout-item md-size-100 flex justify-center gap-4 mt-5">
        <md-button class="md-primary h-[40px] text-3xl" type="submit">
          &gt;
        </md-button>
      </div>
    </validation-form>
  </div>
</template>
<script>
import { validations } from "@/validations/survey";
import RespondentSetting from "./RespondentSetting.vue";
import { dataOts } from "./Respondent.js";
import { FAMILY_LIST, STUDENT_LIST, TEACHER_LIST } from "./index.js";
import Editor from "@tinymce/tinymce-vue";

export default {
  props: ["data", "isEditPage", "isReadOnly", "isCloneSurvey", "isRoleTeacher"],
  components: { RespondentSetting, Editor },
  mixins: [dataOts],
  data() {
    return {
      editorInit: {
        height: 300,
        menubar: "none",
        toolbar: "none"
      },
      date: null,
      // data local
      gerneralLocal: {
        respondentedCount: null,
        respondent: {
          student: null,
          family: null,
          teacher: null,
          other_staffs: null
        },
        STUDENT_LIST,
        FAMILY_LIST,
        TEACHER_LIST,
        respondentedRequire: false,
        survey_validation: validations,
        serverValidations: {}
      },
      // data server
      gerneral_information: {
        title: "",
        description: "",
        effective_end_date: "",
        appearance_report_setting: false,
        respondent_setting: {}
      },
      dataGerneralInformation: null,
      isSettingEdit: false,
      listOptions: {
        student: [],
        family: [],
        teacher: [],
        other_staffs: []
      },
      createdId: null
    };
  },
  created() {
    this.initialize();
  },
  watch: {},
  methods: {
    disabledDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    initialize() {
      if ((this.isEditPage || this.isCloneSurvey) && !this.data.gerneralLocal) {
        this.listOptions = this.data.option_selected;
        this.gerneral_information = this.data.gerneral_information;
        this.createdId = this.data.create_by;
        this.isSettingEdit = true;
      }
      if (this.data.gerneralLocal) {
        this.gerneral_information = this.data.gerneral_information;
        this.gerneralLocal = this.data.gerneralLocal;
        this.listOptions = this.data.optionList;
      }
    },
    getDataRespodentSetting() {
      this.gerneralLocal.respondent = this.renderRespondent("resSetting");
      this.gerneral_information.respondent_setting = this.renderRespondent(
        "respondentFilter"
      );
    },
    renderRespondent(respondent) {
      if (this.isRoleTeacher) {
        return {
          student: this.$refs.studentSetting[respondent],
          family: this.$refs.familySetting[respondent]
        };
      } else {
        return {
          student: this.$refs.studentSetting[respondent],
          family: this.$refs.familySetting[respondent],
          teacher: this.$refs.teacherSetting[respondent],
          other_staffs: this.$refs.otherSetting[respondent]
        };
      }
    },
    checkRespondent(respondentedCheck) {
      respondentedCheck !== null
        ? this.gerneralLocal.respondentedCount++
        : this.gerneralLocal.respondentedCount--;
    },
    validateRespondent() {
      if (this.gerneralLocal.respondentedCount < 1) {
        this.gerneralLocal.respondentedRequire = true;
      } else {
        this.gerneralLocal.respondentedRequire = false;
        this.goToStructure();
      }
    },
    goToStructure() {
      this.getDataRespodentSetting();
      this.dataGerneralInformation = {
        gerneral_information: this.gerneral_information,
        gerneralLocal: this.gerneralLocal,
        optionList: this.renderRespondent("optionResSelected")
      };
      this.$emit("goToStructure", this.dataGerneralInformation);
      this.gerneralLocal.respondentedCount = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-checkbox {
  display: flex;
}

.md-checkbox {
  width: 300px;
}

.checkbox-name {
  color: gray;
  font-size: 16px;
  width: 170px;
}

.md-input {
  width: 220px;
}

.from-submit {
  display: flex;
  justify-content: center;
}

.md-error {
  position: absolute;
  color: var(--md-theme-default-fieldvariant, #ff1744);
  font-size: 12px;
}

.md-title {
  font-size: 18px;
}

.hidden-tooltip {
  display: none;
}

.md-tooltip {
  overflow-wrap: break-word;
}

.required:after {
  content: " *";
  color: red;
}

.md-card img {
  width: 12px;
  height: auto;
}

::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}

.date-disabled {
  background: #fff0;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
}

.not-allowed {
  cursor: not-allowed;
}

::v-deep .md-checkbox.md-disabled .md-checkbox-label,
.md-checkbox.md-disabled .md-checkbox-container {
  opacity: 4.26;
  border-color: rgba(0, 0, 0, 0.54) !important;
  cursor: not-allowed;
}

.md-field .md-textarea[disabled] {
  cursor: not-allowed;
}
</style>
